import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { cn } from '@/lib/styles';
import { BLOG_CATEGORIES_ROW_TEST_IDS } from '@/lib/test-ids';
import { getBlogCategoryLink } from '@/utils/links';
export function BlogCategoriesRow(t0) {
  const $ = _c(3);
  const {
    categories,
    type: t1
  } = t0;
  const type = t1 === undefined ? "large" : t1;
  let t2;
  if ($[0] !== categories || $[1] !== type) {
    t2 = categories?.length > 0 ? <span className="bodyRegularMedium flex flex-wrap" data-test-id={BLOG_CATEGORIES_ROW_TEST_IDS.COMPONENT}>{categories.map((category, index) => {
        if (!category.slug) {
          return null;
        }
        return <span key={category.id} className="flex items-center"><span className={cn("mx-1 leading-none", index === 0 && "hidden")}>·</span><AppLink variant="quaternaryLink" className="no-underline" href={getBlogCategoryLink(category.slug)} data-test-id={BLOG_CATEGORIES_ROW_TEST_IDS.LINK}><span className={cn(type === "small" && "text-base/4")}>{category.name}</span></AppLink></span>;
      })}</span> : null;
    $[0] = categories;
    $[1] = type;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}